import { render, staticRenderFns } from "./RegisterCommonCard.vue?vue&type=template&id=f704d5fa&"
import script from "./RegisterCommonCard.vue?vue&type=script&lang=js&"
export * from "./RegisterCommonCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports